// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppSystemModel from '../../model/app-system-model';
import AppSystemDTO from '../dto/app-system-dto';
import dtoSchema from '../schemas/app-system-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class AppSystemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppSystemDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.name = data.name ?? undefined;
      this.tenantKey = data.tenantKey ?? undefined;
      this.isActive = data.isActive;
      this.caption = data.caption ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  name?: string;
  /**
  */
  tenantKey?: string;
  /**
  */
  isActive?: boolean;
  /**
  * @readonly
  */
  caption?: string;

  static toModel(dto: DeepPartial<AppSystemDTO>): AppSystemModel;
  static toModel(dto: DeepPartial<AppSystemDTO> | undefined | null): AppSystemModel | undefined;
  static toModel(dto: DeepPartial<AppSystemDTO> | undefined | null): AppSystemModel | undefined {
    return dto ? new AppSystemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppSystemModel> | AppSystemModel): AppSystemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      name: unwrapped.name,
      tenantKey: unwrapped.tenantKey,
      isActive: unwrapped.isActive,
      caption: unwrapped.caption,
    } as AppSystemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AppSystemModel, can not map to AppSystemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
